// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlignmentDetailsPopup-module__grid___peQe2 {
  display: grid;
  padding: 15px 30px;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.AlignmentDetailsPopup-module__grid___peQe2 .AlignmentDetailsPopup-module__width75___QqVjw {
  grid-column: 2 span;
}
.AlignmentDetailsPopup-module__grid___peQe2 .AlignmentDetailsPopup-module__width100___fMvRK {
  grid-column: 3 span;
}`, "",{"version":3,"sources":["webpack://./src/popups/AlignmentDetailsPopup/AlignmentDetailsPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ","sourcesContent":[".grid {\n  display: grid;\n  padding: 15px 30px;\n  grid-row-gap: 25px;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width75 {\n    grid-column: 2 span;\n  }\n\n  .width100 {\n    grid-column: 3 span;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `AlignmentDetailsPopup-module__grid___peQe2`,
	"width75": `AlignmentDetailsPopup-module__width75___QqVjw`,
	"width100": `AlignmentDetailsPopup-module__width100___fMvRK`
};
module.exports = ___CSS_LOADER_EXPORT___;
